import { IPaginationParams } from '../../../../types';
import { queryClient } from 'index';
import { getUserId } from '../../../../DefaultService';
import { IIvsEventSimpleProps } from '../../types';

export const IVS_EVENT_CACHE_KEY = 'ivsEvent';

const USER_ID = getUserId();

export const useIvsEventDataStreamCache = () => {
  return {
    getCacheData: (pagination: IPaginationParams): any[] | undefined =>
      queryClient.getQueryData<IIvsEventSimpleProps[]>([
        `${IVS_EVENT_CACHE_KEY}${pagination.pageNumber}`,
        pagination,
        USER_ID,
      ]),
    setCacheData: (
      data: IIvsEventSimpleProps[],
      pagination: IPaginationParams,
    ) =>
      queryClient.setQueryData(
        [`${IVS_EVENT_CACHE_KEY}${pagination.pageNumber}`, pagination, USER_ID],
        data,
      ),
    clearCacheData: () => {
      queryClient
        .getQueryCache()
        .getAll()
        .forEach(({ queryKey }) => {
          if (
            Array.isArray(queryKey) &&
            queryKey[0].startsWith(IVS_EVENT_CACHE_KEY) &&
            queryKey[2] == USER_ID
          ) {
            queryClient.removeQueries({ queryKey });
          }
        });
    },
  };
};
